import { IonPage, IonSpinner } from '@ionic/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { logout } from '../state/loginSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
export const LogoutPage: React.FC = () => {
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	useEffect(() => {
		dispatch(logout());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<IonPage>
			<QuirkIonContent fullscreen={true}>
				<div className="center-align">
					<h4>Logging out...</h4>
					<IonSpinner color="primary" />
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
